import ErrorPage from './default';
import { ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT } from './constants';

function AlreadyPurchaseAdditionalFiber(props) {
  return (
    <ErrorPage
      {...props}
      title={ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT.TITLE}
      description={
        ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT.DESCRIPTION
      }
      iconColor="BLUE"
      iconId="informacion"
      showLink={false}
    />
  );
}
export default AlreadyPurchaseAdditionalFiber;
